import UserAssetSearch from "./UserAssetSearch";
import UserRechargeRelatedAPI from "./UserRechargeRelatedAPI";
import UserTransferRelatedAPI from "./UserTransferRelatedAPI";
import UserWithdrawalRelatedAPI from "./UserWithdrawalRelatedAPI";

export default function Index() {
  return (
    <div>
      <UserAssetSearch />
      <UserRechargeRelatedAPI />
      <UserWithdrawalRelatedAPI />
      <UserTransferRelatedAPI />
    </div>
  );
}
